import { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { createModal } from "../hooks/createModal";
import Menu from "../ui/Menu";
import Card from "../ui/Card";
import Label from "../ui/Label";
import ReportsCustomInventory from "../components/ReportsCustomInventory";
import Divider from "../ui/Divider";
import Space from "../ui/Space";
import Nav from "../ui/Nav";
import { AdjustIcon, CloseTabs, CopyIconInv, DeleteIcon, EditIconInv, ExtrasIcon, HistoryIcon, IndexIcon, LabelIcon, LogIcon, MessageIconInv, MultistoreIcon, NewIcon, OrderIcon, PubstockIcon, ReserveIcon, SearchIconInv, TagIcon, TransferIcon, TrashIcon, ViewIconInv, WebIcon } from "../utils/Icons";
import ProcessingList from "../components/ProcessingList";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import ProcessingDetails from "../components/ProcessingDetails";
import IconNav from "../ui/IconNav";
import { buildFileFromChunks } from "../utils/Utils";
import PurchaseOrderUpdate from "../popups/PurchaseOrderUpdate";
import { ENUMS } from "../utils/Enums";
import Spin from "../ui/Spin";
import { drawPicker } from "../popovers/Picker";
import OrderTotalsBySection from "../components/order_processing/OrderTotalsBySection";
import ProcessingPreview from "../components/ProcessingPreview";
import ProcessOptions from "../components/order_processing/ProcessOptions";
import ProcessOrderForm from "../components/order_processing/ProcessOrderForm";
import InventoryDetails from "../components/InventoryDetails";

export default function OrderProcessingController(props) {

    const { controller = "", signal = {}, setController = () => { } } = props;

    const route = ROUTES.PROCESSING.PROCESSING;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [selectedList, setSelectedList] = useState([]);
    const [fullData, setFullData] = useState({});
    const [items, setItems] = useState([]);
    const [align, setAlign] = useState("auto");
    
    const [filters, setFilters] = useState({ limit: 45, sort: "status", send_via: "", minimum: "", pending_separators: "", supplier_types: "", only_pending: false })
    const row_key = "purchase_order_id";

    const [state, setState] = useState({
        edit: false,
        view: false,
    })

    const processing_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { key: KBD.ENTER, action: () => { switchView() } },
        // { disabled: (window.beta), text: "Edt", key: KBD.E, action: () => { switchEdit() } },
        { text: "Edt", key: KBD.E, action: () => { switchEdit() }, icon: <EditIconInv />  },
        { text: "Flt" },
        { text: "Indx", icon: <IndexIcon /> },
        { text: "Log", icon: <LogIcon /> },
        { key: KBD.O, text: "Ok", action: () => { toggleOk(selected) } },
        { key: KBD.P, text: "Process", action: () => { drawProcessOptions(); } },
        { key: KBD.R, text: "Rettl", action: () => { reTotal(selected) } },
        { text: "Search", icon: <SearchIconInv /> },
        { text: "Telephone" },
        { key: KBD.U, text: "Update", action: () => { drawUpdate() } },
        { key: KBD.V, text: "View", action: () => { switchView() }, icon: <ViewIconInv /> },
        { key: KBD.X, text: "Xtra", action: () => drawExtra(), icon: <ExtrasIcon /> },
    ]

    useEffect(() => {

        const cleanup = listen(controller, route, processing_nav);
        return cleanup;
    }, [processing_nav, selected])

    const switchEdit = () => {

        setState(prevState => {
            if (!prevState.edit) {
                window.bm_state.value = ROUTES.PROCESSING.EDIT;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                edit: !prevState.edit,
            }
        })
    }

    const switchView = () => {

        setState(prevState => {
            if (!prevState.view) {
                window.bm_state.value = ROUTES.PROCESSING.VIEW;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                view: !prevState.view,
            }
        })
    }

    const updateRow = (_row) => {
        let _d = [...data];
        let _f = _d.findIndex(item => item?.[row_key] === _row?.[row_key]);
        if (_f > -1) {
            _d[_f] = _row;
            setSelected(_d[_f]);
            setData(_d);
        }
    }

    useEffect(() => {

        return;

        if (!selectedList?.order_id || !state.view) { return; }
        pubCall("stock.getSingleExtras", { stock_id: "selectedList.order_id" }, (_s, _r) => {
            setFullData(_r);
        })



    }, [selectedList, state.view])


    const drawOrderForm = (_mark_as_sent = false) => {

        window.bm_state.value = ROUTES.PROCESSING.ORDER_FORM;

        const via = selected?.send_via ? ` (${selected.send_via})` : "";

        const edi_format = selected?.supplier?.edi_format; 

        const target = (edi_format === "I") ? "(Ingram format)" : via; 
        

        const title = (_mark_as_sent) ? "Mark Order as Sent" : "Prepare Order Options " + target
        createModal({
            offset: [0, -120],
            title: title,
            component:
                <ProcessOrderForm
                    
                    mark_as_sent={_mark_as_sent}
                    controller={controller}
                    route={ROUTES.PROCESSING.ORDER_FORM}
                    item={selected}
                />,
            closable: true,
            callback: (e) => {
                window.bm_state.value = route;
            }
        })


    }

    const drawProcessOptions = () => {
        window.bm_state.value = ROUTES.PROCESSING.PROCESS_OPTIONS;
        createModal({
            offset: [0, -120],
            title: "Process Options",
            component:
                <ProcessOptions
                    controller={controller}
                    route={ROUTES.PROCESSING.PROCESS_OPTIONS}
                    item={selected}
                />,
            closable: true,
            callback: (e) => {

                switch (e?.value || "") {
                    case 1:
                        drawOrderForm()
                        break; 
                    case 3:
                        drawOrderForm(true)
                        break;
                    default:
                        window.bm_state.value = route;
                        break;
                }



            }
        })
    }

    const toggleOk = (_selected = selected) => {

        setLoading(true);
        pubCall("purchase_order.toggleOk", { purchase_order_id: selected?.purchase_order_id, is_ok: !_selected?.ready }, (_s, _r) => {
            if (_s) {
                updateRow(_r);
            } else {
                showError(_r);
            }
            setLoading(false);
        })

    }

    useEffect(() => {
        if (!row_key) { return; }

        let stale = false;
        const debouncerTimer = setTimeout(() => {
            pubCall("purchase_order.getSingleExtras", { "purchase_order_id": selected?.purchase_order_id }, (_s, _r) => {
                if (stale) { return; }
                if (_s) {
                    setSelectedItem(_r);
                    setSelectedList(_r?.first_items?.[0] || {});
                } else {
                    showError(_r);
                }
            });
        }, 300);

        return () => {
            stale = true;
            clearTimeout(debouncerTimer);
        }
    }, [selected?.purchase_order_id]);

    const listSelected = (selectedItem?.purchase_order?.[row_key] === selected?.[row_key])
        ? selectedItem.purchase_order
        : selected;

    const reTotal = (_selected = selected) => {
        setLoading(true)
        pubCall("purchase_order.retotal", { purchase_order_id: _selected?.[row_key] }, (_s, _r) => {
            if (_s) {
                console.log(JSON.stringify(_r, null, 2))
            } else {
                showError(_r);
            }
        })
    }

    const runUpdate = (_filters) => {
        setLoading(true)
        pubCall("purchase_order.update", _filters, (_s, _r) => {
            if (_s) {
                showMessage("Update complete.")
            } else {
                showError(_r);
            }
            setLoading(false)
        })
    }


    const drawUpdate = () => {
        window.bm_state.value = ROUTES.PROCESSING.UPDATE;
        createModal({
            component: <PurchaseOrderUpdate controller={controller} filters={filters} options={ENUMS.ORDER_UPDATE_OPTIONS} route={ROUTES.PROCESSING.UPDATE} />, closable: true, title: <>Update</>, callback: (_filter) => {
                if (_filter) {
                    runUpdate(_filter);
                }
                window.bm_state.value = route;
            }
        })
    }


    const drawOrderTotalsBySection = () => {
        window.bm_state.value = ROUTES.PROCESSING.ORDER_TOTALS_BY_SECTION;
        createModal({
            component: <OrderTotalsBySection item={selected} controller={controller} route={ROUTES.PROCESSING.ORDER_TOTALS_BY_SECTION} />, closable: true, title: <>Order totals by section</>, callback: (_filter) => {
                if (_filter) {
                    runUpdate(_filter);
                }
                window.bm_state.value = route;
            }
        })
    }

    const drawExtra = () => {

        const extraOptions = [
            { value: "R", label: "Reprint / View this PO", key: KBD.R },
            { value: "V", label: "Void this PO (revert to Pending)", key: KBD.V },
            { value: "A", label: "Change the PO#", key: KBD.A },
            { value: "B", label: "Change the cancel date (use <E>dit)", key: KBD.B },
            { value: "C", label: "Change discounts on the PO", key: KBD.C },
            { value: "D", label: "Change publication dates", key: KBD.D },
            { value: "E", label: "Change the Supplier", key: KBD.E },
            { value: "F", label: "Change the Order status for items on the PO", key: KBD.F },
            { value: "T", label: "View order totals by section", key: KBD.T },
        ];

        drawPicker({
            controller: controller,
            show_keys: true,
            allow_keys: true,
            value: "", title: "Notify Via", closeable: true, height: 300, ref: null, route: route, close: () => { }, callback: (e) => {
                if (e) {
                    switch (e) {
                        case "T":
                            setTimeout(() => {
                                drawOrderTotalsBySection()
                            }, 10)

                            break;
                        default:
                            break
                    }
                }
            }, offset: [0, 10],
            options: extraOptions
        })
    }


    return (
        <div className="controller">
            <Spin loading={loading}>
                <div style={{ height: "calc(100vh - 74px)", minHeight: "650px", gap: "15px" }}>
                    <div style={{ display: "flex" }}>
                        <ProcessingList
                            controller={controller}
                            loading={loading}
                            setLoading={setLoading}
                            route={route}
                            data={data}
                            setData={setData}
                            selected={listSelected}
                            setSelected={setSelected}
                            signal={signal}
                            align={align}
                            setAlign={setAlign}
                            view={!state.view}
                            filters={filters}
                            setFilters={setFilters}
                            row_key={row_key}
                        />
                        <ProcessingDetails
                            controller={controller}
                            setSelected={setSelected}
                            items={items}
                            switchEdit={switchEdit}
                            edit={state.edit}
                            view={!state.view}
                            route={ROUTES.PROCESSING.EDIT}
                            callback={(_saved, _r) => {
                                if (_saved && _r?.[row_key]) {
                                    updateRow({ ...selected, ..._r });
                                    setSelectedItem(prev => ({ ...prev, purchase_order: { ...prev?.purchase_order, ..._r } }));
                                }
                                switchEdit();
                            }}
                            setItems={setItems}
                            selected={selectedItem.purchase_order}
                        />
                        {(state.view && 
                        <>
                            <div style={{ width: "100%"}}>
                                <InventoryDetails 
                                    monthly_sold={fullData?.monthly_sold} 
                                    grid_info={fullData?.grid_info} 
                                    controller={controller} 
                                    updateRow={() => { }} 
                                    switchEdit={() => { }} 
                                    stock_data={fullData?.stock} 
                                />
                            </div>
                        </>)}
                    </div>
                    <div className="shim" />
                    <ProcessingPreview 
                        controller={controller}
                        selected={selectedList}
                        setSelectedList={setSelectedList}
                        data={selectedItem.first_items} 
                        view={state.view}
                        setView={switchView}
                        route={ROUTES.PROCESSING.VIEW}
                        callback={() => {
                            switchView();
                        }}
                    />

                    <Divider />
                    <div style={{ 'height': "30px" }}>
                        <Space>
                            <IconNav nav={processing_nav} />
                        </Space>
                    </div>
                </div>
            </Spin>
        </div>
    )
}


